import React from "react";
import { TextField, Autocomplete, MenuItem } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const MultiSelectV2 = (props) => {
  return (
    <Autocomplete
      key={props.key}
      sx={{ m: 1 }}
      multiple
      options={props.options}
      value={props.value} // controlled value
      getOptionLabel={(option) => option.label ?? option.value}
      disableCloseOnSelect
      isOptionEqualToValue={(option, value) => option.value === value.value}
      onChange={(e, newValue) => props.onChange(newValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={props.label}
          placeholder={props.placeholder}
        />
      )}
      renderOption={(props, option, { selected }) => (
        <MenuItem
          {...props}
          key={option.value}
          value={option.value}
          sx={{ justifyContent: "space-between" }}
        >
          {option.label ?? option.value}
          {selected ? <CheckIcon color="info" /> : null}
        </MenuItem>
      )}
    />
  );
};



export default MultiSelectV2;